import { Controller, type FieldValues } from 'react-hook-form';
import { type SelectControllerProps } from './types';
import { Select } from '.';

export const SelectController = <T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  required,
  placeholder,
  options,
  rules,
  className,
  defaultValue,
  disabled,
  readOnly,
  variant,
  leftIcon,
  leftSlot,
}: SelectControllerProps<T>): React.ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    defaultValue={defaultValue}
    render={({ field }) => (
      <Select
        className={className}
        label={label}
        helperText={helperText}
        required={required}
        placeholder={placeholder}
        options={options}
        value={field.value}
        onValueChange={field.onChange}
        disabled={disabled}
        readOnly={readOnly}
        variant={variant}
        leftIcon={leftIcon}
        leftSlot={leftSlot}
      />
    )}
  />
);
